import List from "@/modules/users/components/List"
const ExpoertList: React.FC = () => {
  return <List></List>
}

export default ExpoertList
